import React, { useState, useCallback } from "react";
import styled from "styled-components";
import { SimpleDialog, Button } from "simple-ui-components";

import CloseIcon from "@mui/icons-material/Close";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import { ListStyled, MainIcon } from "../../theme";
import { ReplaceWord } from "../shared/utility";
import { getTranslation } from "../languageProvider";

export const EquipmentsDetailWithAddRemove = ({
  equipment,
  Add,
  Select,
  length,
  index,
  indexPoint,
  pointId,
  Remove,
  isStarted,
  SwitchIndex,
}) => {
  const { Dialog, DialogBody, DialogFooter } = SimpleDialog;

  const [open, setOpen] = useState(false);

  const selectHandler = () => Select && Select(equipment);
  const addHandler = () => Add && Add(equipment);
  const removeHandler = () => {
    if (isStarted) {
      setOpen(true);
    } else {
      Remove && Remove(pointId ? pointId : equipment.id);
    }
  };
  const handleClose = useCallback(() => setOpen(false), []);
  const removePointClickHandler = useCallback(() => {
    Remove && Remove(pointId ? pointId : equipment.id);
    setOpen(false);
  }, [Remove, pointId, equipment]);

  const upClickHandler = () => {
    SwitchIndex && index !== 0 && SwitchIndex("up", index, indexPoint, pointId);
  };
  const downClickHandler = () => {
    SwitchIndex &&
      index !== length - 1 &&
      SwitchIndex("down", index, indexPoint, pointId);
  };
  return (
    <ListStyled>
      <MainIcon color={equipment.state.color}>
        <img src={equipment.icon} alt={equipment.serialNumber} />
      </MainIcon>
      <div className="detail" onClick={selectHandler}>
        {equipment.serialNumber}
        <span
          className={`${!equipment.client && "error"}`}
          data-translate="0153"
        >
          {equipment.client ? equipment.client.name : getTranslation("0153")}
        </span>
      </div>
      {Remove && (
        <span className="remove" onClick={removeHandler}>
          <RemoveOutlinedIcon />
        </span>
      )}
      {Add && (
        <span className="add" onClick={addHandler}>
          <AddOutlinedIcon />
        </span>
      )}
      {SwitchIndex && length > 1 && (
        <UpDownArrowStyled>
          <ArrowDropUpIcon
            onClick={upClickHandler}
            className={index === 0 ? "disable" : ""}
          />
          <ArrowDropDownIcon
            onClick={downClickHandler}
            className={index === length - 1 ? "disable" : ""}
          />
        </UpDownArrowStyled>
      )}
      <Dialog
        theme="default"
        size="sm"
        close={handleClose}
        open={open}
        title={`${getTranslation("0154")} ${getTranslation("0035")}`}
      >
        <DialogBody>
          <span data-translate="0155">{getTranslation("0155")}</span>
          <br />
          <span className="danger" data-translate="0035,0151">
            {getTranslation("0151") &&
              ReplaceWord(
                getTranslation("0151"),
                "**NAME**",
                getTranslation("0035")
              )}
          </span>
        </DialogBody>
        <DialogFooter multiple={true}>
          <Button
            type="button"
            clicked={removePointClickHandler}
            icon={<CloseIcon />}
            text={getTranslation("0154")}
            className="btn-secondary"
            theme="danger"
            style={{ marginLeft: "auto" }}
          />
        </DialogFooter>
      </Dialog>
    </ListStyled>
  );
};

const UpDownArrowStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
      display:flex;
      flex-direction:column;
      justify-content: center;
      align-items: center;
      >svg{
        width:30px;
        :hover{
          color:rgba(${current.white});
          background:rgba(${current.green});
        }
      }
    `;
  }}
`;
